// @flow
import {
  createSelector,
} from 'reselect';
import * as R from 'ramda';

import type {
  State,
  Selector,
} from '../types';

import {
  getUiState,
} from './ui';

import {
  getWorklogsGroupedByISODate,
} from './worklogs';

export const getTimeWorked: Selector<State, any, number> = createSelector(
  [
    getWorklogsGroupedByISODate,
    getUiState('calendarSelection'),
  ],
  (
    worklogs,
    calendarSelection,
  ) => {
    if (calendarSelection.length === 0) {
      const values: Array<Array<any>> = R.values(worklogs);
      const flattened = R.flatten(values);
      return flattened.reduce(
        (v, w: *) => (v + w.timeSpentSeconds), // don't know how to fix *
        0,
      );
    }
    const formattedDays = calendarSelection.map(dt => dt.toFormat('yyyy-MM-dd'));
    const daysToCalculate = R.intersection(formattedDays, R.keys(worklogs));
    const filtered = R.pick(
      daysToCalculate,
      worklogs,
    );
    const values: Array<Array<any>> = R.values(filtered);
    const flattened = R.flatten(values);
    const result = flattened.reduce(
      (v, w: *) => (v + w.timeSpentSeconds), // don't know how to fix *
      0,
    );
    return result;
  },
);

export const getCalendarSelection: Selector<State, any, number> = createSelector(
  getUiState('calendarSelection'),
  calendarSelection => (
    calendarSelection.reduce(
      (acc, dt) => ({
        ...acc,
        [dt.toISODate()]: true,
      }),
      {},
    )
  ),
);
